export enum categoryActionsTypes {
  GET_CATEGORY_ITMES_REQUEST = 'GET_CATEGORY_ITMES_REQUEST',
  GET_CATEGORY_ITMES_SUCCESS = 'GET_CATEGORY_ITMES_SUCCESS',
  GET_CATEGORY_ITMES_FAILURE = 'GET_CATEGORY_ITMES_FAILURE',
  SET_PRODUCT_COST = 'SET_PRODUCT_COST',
}
